import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import icon_type_link from "../../Assets/svg/icon_type_link.svg";

export default function C_E_LINK({
  tempValue,
  onChange,
  onBlur,
  onKeyDown,
  inPopup = false,
}) {
  const properties_state = useSelector((state) => state.properties);
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  // Auto-focus only in grid cell mode
  useEffect(() => {
    if (!inPopup && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inPopup]);

  const handleIconClick = (e) => {
    e.stopPropagation();

    if (!tempValue) return;

    let url = tempValue.trim();
    // Check if the URL already starts with http:// or https://
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }

    // Open in a new tab securely
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleKeyDownLocal = (e) => {
    if (e.key === "Enter" || e.key === "Escape") {
      if (inPopup) {
        // Force blur in popup mode so the helper text hides and changes save
        e.target.blur();
      }
      if (onKeyDown) onKeyDown(e);
    }
  };

  // 1. POPUP MODE
  if (inPopup) {
    const mode_map = properties_state.mode_map; //editor || viewer
    return (
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "stretch",
            gap: "8px",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          {/* Clickable Icon Visual */}
          <div
            className="badge_small background_grey_light"
            onClick={handleIconClick}
            title={tempValue ? "Open link" : "No link provided"}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              margin: 0,
              padding: "0 12px",
              cursor: tempValue ? "pointer" : "default",
              opacity: tempValue ? 1 : 0.5,
              borderRadius: "4px",
              border: "1px solid #ccc", // Optional: matches input border styling
            }}
          >
            <img
              src={icon_type_link}
              alt="Link"
              style={{ width: "14px", height: "14px", objectFit: "contain" }}
            />
          </div>

          <input
            disabled={mode_map !== "editor"}
            ref={inputRef}
            type="url"
            value={tempValue}
            onChange={onChange}
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
              setIsFocused(false);
              if (onBlur) onBlur(e);
            }}
            onKeyDown={handleKeyDownLocal}
            placeholder="https://..."
            className="input"
            style={{
              width: "100%",
              boxSizing: "border-box",
            }}
          />
        </div>

        {/* Helper Text */}
        {isFocused && (
          <p
            className="text_small"
            style={{ margin: "4px 0 0 0", color: "#666", fontSize: "12px" }}
          >
            Press <strong>Enter</strong> to save
          </p>
        )}
      </div>
    );
  }

  // 2. GRID CELL MODE
  return (
    <input
      ref={inputRef}
      type="url"
      value={tempValue}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={handleKeyDownLocal}
      placeholder="https://..."
      style={{
        width: "100%",
        fontSize: "inherit",
        fontFamily: "inherit",
        color: "inherit",
        backgroundColor: "#dedede", // Specified editor background
        padding: "0 8px", // Added slight horizontal padding
        margin: "0",
        border: "none",
        boxSizing: "border-box",
        outline: "none",
        display: "block",
        lineHeight: "1.5",
        appearance: "none",
        height: "100%",
        minHeight: "0",
        borderRadius: "0",
      }}
    />
  );
}
